import { loginByEmail, logout, getInfo } from 'api/login';
import Cookies from 'js-cookie';

const user = {
  state: {
    user: '',
    status: '',
    email: '',
    code: '',
    uid: undefined,
    auth_type: '',
    token: Cookies.get('Admin-Token'),
    url: Cookies.get('Admin-Url'),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    },
    firstFlag:0,
    concernArea:"",
    concernIndustry:"",
    concernCompany:[],
    nextPage:"",
    isBindWechat:false,
    isSendNews:false,
    concernCompanyNum:22,
    systemName:"/jzhk",
  },

  mutations: {
    SET_AUTH_TYPE: (state, type) => {
      state.auth_type = type;
    },
    SET_CODE: (state, code) => {
      state.code = code;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_URL: (state, url) => {
      state.url = url;
    },
    SET_UID: (state, uid) => {
      state.uid = uid;
    },
    SET_EMAIL: (state, email) => {
      state.email = email;
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction;
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting;
    },
    SET_STATUS: (state, status) => {
      state.status = status;
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_FIRST_FLAG: (state, flag) => {
      state.firstFlag = flag;
    },
    SET_CONCERN_AREA: (state, value) => {
      state.concernArea = value;
    },
    SET_CONCERN_INDUSTRY: (state, value) => {
      state.concernIndustry = value;
    },
    SET_CONCERN_COMPANY: (state, value) => {
      state.concernCompany = value;
    },
    SET_NEXT_PAGE: (state, value) => {
      state.nextPage = value;
    },
    LOGIN_SUCCESS: () => {
    },
    LOGOUT_USER: state => {
      state.user = '';
    },
    SET_ISBINDWECHAT:(state,value)=>{
      state.isBindWechat = value
    },
    SET_ISSENDNEWS:(state,value)=>{
      state.isSendNews = value
    },
    SET_CONCERN_COMPANY_NUM:(state,value) =>{
      state.concernCompanyNum = value;
    },
    SET_SYSTEM_NAME:(state,value) =>{
      state.systemName = value;
    }
  },

  actions: {
    // 邮箱登录
    LoginByEmail({ commit }, userInfo) {
      const email = userInfo.email.trim();
      return new Promise((resolve, reject) => {
        loginByEmail(email, userInfo.password).then(response => {
          const data = response.data.data;
          if(response.data.code == 1){
            Cookies.set('Admin-Token', data.token);
            commit('SET_TOKEN', data.token);
            commit('SET_EMAIL', email);
            resolve();
          }else {
            alert(data);
            this.$Message.error(data);
            resolve();
          }
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const data = response.data;
          commit('SET_ROLES', data.role);
          commit('SET_NAME', data.name);
          Cookies.set('SET_NAME', data.name);
          commit('SET_AVATAR', data.avatar);
          commit('SET_UID', data.uid);
          commit('SET_INTRODUCTION', data.introduction);
          commit('SET_CONCERN_AREA', data.concernArea);
          commit('SET_CONCERN_INDUSTRY', data.concernIndustry);
          commit('SET_CONCERN_COMPANY', data.companys);
          commit('SET_ISBINDWECHAT', data.bindWechat);
          commit('SET_ISSENDNEWS', data.sendNews);
          commit('SET_SYSTEM_NAME', data.systemName);
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 第三方验证登录
    LoginByThirdparty({ commit, state }, code) {
      return new Promise((resolve, reject) => {
        commit('SET_CODE', code);
        loginByThirdparty(state.status, state.email, state.code, state.auth_type).then(response => {
          commit('SET_TOKEN', response.data.token);
          Cookies.set('Admin-Token', response.data.token);
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },


    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          Cookies.remove('Admin-Token');
          resolve();
        }).catch(error => {
          reject(error);
        });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        Cookies.remove('Admin-Token');
        Cookies.remove('pi_zheng-adt-server-session-id');
        resolve();
      });
    },
    // 动态修改权限
    ChangeRole({ commit }, role) {
      return new Promise(resolve => {
        commit('SET_ROLES', [role]);
        commit('SET_TOKEN', role);
        Cookies.set('Admin-Token', role);
        resolve();
      })
    },
    setFirstFlag: ({ commit },value) => {
      commit('SET_FIRST_FLAG',value)
    },
    setConcernArea: ({ commit },value) => {
      commit('SET_CONCERN_AREA',value)
    },
    setConcernIndustry: ({ commit },value) => {
      commit('SET_CONCERN_INDUSTRY',value)
    },
    setToken: ({ commit },value) => {
      commit('SET_TOKEN',value);
      Cookies.set('Admin-Token', value);
    },
    setUrl: ({ commit },value) => {
      commit('SET_URL',value);
      Cookies.set('Admin-Url', value);
    },
    setNextPage: ({ commit },value) => {
      commit('SET_NEXT_PAGE',value);
    },
    setConcernCompanyNum: ({ commit },value) => {
      commit('SET_CONCERN_COMPANY_NUM',value)
    },
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js